import CountryService from '@/core/collections/country/country.service';
import { Country } from '@nxtpeople/nxt-vue-library';
import { Module } from 'vuex';

const countryService = new CountryService();

const CountryStore: Module<any, any> = {
   namespaced: true,
   state: {
      countries: [],
   },
   getters: {},
   mutations: {
      SET_COUNTRIES(state, countries: Array<Country>) {
         state.countries = countries;
      },
      ADD_COUNTRY(state, country: Country) {
         state.countries.push(country);
      },
   },
   actions: {
      async fetch({ commit }, { search_term }) {
         commit('SET_COUNTRIES', []);
         const COUNTRIES = await countryService.get(search_term).then((response) => response.data);
         commit('SET_COUNTRIES', COUNTRIES);
      },
   },
};

export default CountryStore;
